import { merge } from 'lodash';

import { initialState } from 'helpers/comps/database_table_constants';

export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export function clearFilters(initialState) {
  return { initialState: initialState, type: CLEAR_FILTERS };
}

export const CHANGE_ADDRESS_FILTER_GROUP = 'CHANGE_ADDRESS_FILTER_GROUP';
export function changeAddressFilterGroup(addressFilter) {
  return { addressFilter: addressFilter, type: CHANGE_ADDRESS_FILTER_GROUP };
}

export const CHANGE_INDUSTRIAL_FILTER_GROUP = 'CHANGE_INDUSTRIAL_FILTER_GROUP';
export function changeIndustrialFilterGroup(industrialFilter) {
  return { industrialFilter: industrialFilter, type: CHANGE_INDUSTRIAL_FILTER_GROUP };
}

export const CHANGE_LEASE_FILTER_GROUP = 'CHANGE_LEASE_FILTER_GROUP';
export function changeLeaseFilterGroup(leaseFilter) {
  return { leaseFilter: leaseFilter, type: CHANGE_LEASE_FILTER_GROUP };
}

export const CHANGE_LEASE_PAGE = 'CHANGE_LEASE_PAGE';
export function changeLeasePage(page) {
  return { page: page, type: CHANGE_LEASE_PAGE };
}

export const CHANGE_LEASE_SORT = 'CHANGE_LEASE_SORT';
export function changeLeaseSort(sort) {
  return { sort: sort, type: CHANGE_LEASE_SORT };
}

export const CHANGE_SALE_PAGE = 'CHANGE_SALE_PAGE';
export function changeSalePage(page) {
  return { page: page, type: CHANGE_SALE_PAGE };
}

export const CHANGE_SALE_SORT = 'CHANGE_SALE_SORT';
export function changeSaleSort(sort) {
  return { sort: sort, type: CHANGE_SALE_SORT };
}

export const CHANGE_PROPERTY_FILTER_GROUP = 'CHANGE_PROPERTY_FILTER_GROUP';
export function changePropertyFilterGroup(propertyFilter) {
  return { propertyFilter: propertyFilter, type: CHANGE_PROPERTY_FILTER_GROUP };
}

export const CHANGE_SALE_FILTER_GROUP = 'CHANGE_SALE_FILTER_GROUP';
export function changeSaleFilterGroup(saleFilter) {
  return { saleFilter: saleFilter, type: CHANGE_SALE_FILTER_GROUP };
}

export const CHANGE_CUSTOM_FIELD_FILTERS = 'CHANGE_CUSTOM_FIELD_FILTERS';
export function changeCustomFieldFilters(changes) {
  return { type: CHANGE_CUSTOM_FIELD_FILTERS, changes };
}

export const CHANGE_SEARCH_TEXT = 'CHANGE_SEARCH_TEXT';
export function changeSearchText(value) {
  return { value: value, type: CHANGE_SEARCH_TEXT };
}

export const SET_FULL_QUERY = 'SET_FULL_QUERY';
export const setFullQuery = query => (
  (dispatch) => {
    const newQueryState = merge({}, initialState, query);
    dispatch({ type: SET_FULL_QUERY, query: newQueryState });
  }
);

export const SELECT_AVAILABILITY = 'SELECT_AVAILABILITY';
export function selectAvailability(key, value) {
  return { id: key, value: value, type: SELECT_AVAILABILITY };
}

export const SELECT_ASSET_CLASS = 'SELECT_ASSET_CLASS';
export function selectAssetClass(key, value) {
  return { role: key, value: value, type: SELECT_ASSET_CLASS };
}

export const SELECT_BUILDING_CLASS = 'SELECT_BUILDING_CLASS';
export function selectBuildingClass(key, value) {
  return { role: key, value: value, type: SELECT_BUILDING_CLASS };
}

export const SELECT_INVESTMENT_TYPE = 'SELECT_INVESTMENT_TYPE';
export function selectInvestmentType(key, value) {
  return { key, value, type: SELECT_INVESTMENT_TYPE };
}

export const SELECT_PROPERTY_GROUP = 'SELECT_PROPERTY_GROUP';
export function selectPropertyGroup(id) {
  return { researchGroupId: id, type: SELECT_PROPERTY_GROUP };
}

export const SET_AVAILABILITIES = 'SET_AVAILABILITIES';
export function setAvailabilities(availabilities) {
  return { availabilities: availabilities, type: SET_AVAILABILITIES };
}

export const SET_ASSET_CLASSES = 'SET_ASSET_CLASSES';
export function setAssetClasses(assetClasses) {
  return { assetClasses: assetClasses, type: SET_ASSET_CLASSES };
}

export const SET_BUILDING_CLASSES = 'SET_BUILDING_CLASSES';
export function setBuildingClasses(buildingClasses) {
  return { buildingClasses: buildingClasses, type: SET_BUILDING_CLASSES };
}

export const SET_INVESTMENT_TYPES = 'SET_INVESTMENT_TYPES';
export function setInvestmentTypes(investmentTypes) {
  return { investmentTypes, type: SET_INVESTMENT_TYPES };
}

export function clearFiltersIfEmpty() {
  return (dispatch, getState) => {
    const query = getState().query;

    const availabilities = query.availabilities || [];
    const assetClasses = query.assetClasses || [];
    const buildingClasses = query.buildingClasses || [];
    const investmentTypes = query.investmentTypes || [];

    const addressFilter = Object.keys(query.addressFilter).every((key) => {
      if (key === "cities") return query.addressFilter[key].length === 0;
      return query.addressFilter[key] === "";
    });

    const saleFilter = Object.values(query.saleFilter).every(o => o === "");
    const leaseFilter = Object.values(query.leaseFilter).every(o => o === "");

    const propertyFilter = Object.keys(query.propertyFilter).every((key) => {
      if (key === "lotUnits") return true;
      return query.propertyFilter[key] === "";
    });

    const filtersAreEmpty = addressFilter && saleFilter && propertyFilter && leaseFilter;
    const nothingIsSelected = buildingClasses.length === 0 &&
                              availabilities.length === 0 &&
                              assetClasses.length === 0 &&
                              investmentTypes.length === 0;

    if (filtersAreEmpty && nothingIsSelected && query.searchText === "") {
      dispatch(clearFilters());
    }
  };
}
